import React from 'react';
import DefaultLayout from '../../layouts/default';
import RotaOverview from './components/overview';
import RotaStats from './components/stats';
import RotaFrequency from './components/frequency';     
import RotaTodayAssignments from './components/todayAssignment';
import RotaTable from "./components/rotaTable";
import UpcommingAndOverdue from "./components/upcommingAndOverdue";
import { CreateAndUpdateRotaProvider } from './contexts/createAndUpdateRotaContext';

const RotaPage = () => {
  return (
    <CreateAndUpdateRotaProvider>
      <DefaultLayout className="p-10">
            <RotaOverview />
            <RotaStats />
            <section className="grid grid-cols-12 gap-4">
                <div className="col-span-4">
                      <RotaFrequency />
                      <RotaTodayAssignments />
                </div>
                <div className="col-span-8">
                      <RotaTable />
                      <UpcommingAndOverdue />
                </div>
            </section>
      </DefaultLayout>
    </CreateAndUpdateRotaProvider>
  );
};

export default RotaPage;